import restApi from '@/utils/rest-api'

export default {
    fetchAllCountries() {
        const postFix = localStorage.getItem('lang') === 'el' ? 'Greek' : 'English'
        let sort = ['order', 'ASC', 'name' + postFix, 'ASC']
        return restApi({
            url: `/countries?sort=${encodeURI(JSON.stringify(sort))}`,
            method: 'get'
        })
    }
}
